import api from './ApiService.js';

const AuthService = {
    async login(password) {
        try {
         
            const response = await api.post('/api/auth/login', { password });
            
            if (response.data && response.data.token) {
                localStorage.setItem('token', response.data.token);
                localStorage.setItem('premo_password', password);
           
                return response.data;
            } else {
                throw new Error('No se recibió el token del servidor');
            }
        } catch (error) {
            console.error('AuthService: Login error:', error.response?.data?.message || error.message);
            
            // Clear any existing tokens on login failure
            localStorage.removeItem('token');
            localStorage.removeItem('premo_password');
            
            if (error.response?.status === 401) {
                throw new Error('Contraseña incorrecta');
            } else if (error.response?.status >= 500) {
                throw new Error('Error del servidor. Intente nuevamente.');
            } else {
                throw new Error(error.response?.data?.message || 'Error de conexión');
            }
        }
    },
    
    async verify() {
        try {
            const token = localStorage.getItem('token');
            if (!token) {
                return false;
            }
            
           
            const response = await api.get('/api/auth/verify');
            const isValid = response.data.valid;
     
            return isValid;
        } catch (error) {
            console.error('AuthService: Token verification failed:', error.message);
            return false;
        }
    },
    
    logout() {
       
        localStorage.removeItem('token');
        localStorage.removeItem('premo_password');
    },
    
    isAuthenticated() {
        const token = localStorage.getItem('token');
        return !!token;
    },
    
    getStoredPassword() {
        return localStorage.getItem('premo_password');
    }
};

export default AuthService;
